import { useQuery } from '@tanstack/react-query';
import { projectService } from '@services/project';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import { ProjectFilters } from '@models/project.model';

export const PROJECTS_PAGINATED_QUERY_KEY = 'projects-paginated';

export const useProjectsPaginated = (filters: ProjectFilters = {}) => {
  const { userId } = useAppSelector((state: RootState) => state.user);

  return useQuery({
    queryKey: [PROJECTS_PAGINATED_QUERY_KEY, userId, filters],
    queryFn: () => projectService.getProjectsByUserPaginated(userId!, filters),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    placeholderData: (previousData) => previousData, // Keep previous data while fetching new data
  });
};